var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pallet-rack-sector--component",staticStyle:{"position":"relative"}},_vm._l((Number(_vm.sector.sectionCount)),function(index){return _c('div',{key:index,staticClass:"pallet-rack-section-container",staticStyle:{"position":"absolute"}},[_c('div',{style:({ fontSize: _vm.size + 'px', position: 'relative' })},[_c('div',{style:({
          height: '24px',
          justifyContent: 'center',
          position: 'absolute',
          top: '4px',
          left: _vm.mmToEm(
            +_vm.includeImpactProtectors ? 235 : 0 + _vm.selectedUprights.width / 2
          ),
          width: _vm.mmToEm(
            (_vm.sector.beam.length + _vm.selectedUprights.width) *
              Number(_vm.sector.sectionCount)
          ),
          backgroundColor: _vm.sector.backgroundColor,
          color: _vm.sector.textColor
        }),attrs:{"id":"sectorHeader","data-cy":"section-group-tag-b"}},[_c('div',{staticStyle:{"font-size":"13px","font-weight":"800","margin-top":"2px","width":"inherit","display":"flex","flex-direction":"row","justify-content":"inherit","padding-left":"0.25em","padding-right":"0.25em"}},[_c('div',{staticStyle:{"overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v("\n            Sektionsgrupp\n          ")]),_c('div',[_vm._v(" "+_vm._s(_vm.sector.index + 1))])])])]),_c('pallet-rack-section',{attrs:{"index":index - 1,"sector":_vm.sector,"size":_vm.size}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }